export const EMPTY_MESSAGE = {
  type: '',
  title: '',
  body: ''
};

export const MAX_ROWS_FORM = 180;

export const MAX_LENGTH_QUANTITY_CUSTOMER_ITEM = 5;

export const MOBILE_HIDE_CELL_CLASSNAME = 'd-none d-md-block';
export const QO_FORM_COL_WIDTH_ICON = '37px';
export const QO_FORM_COL_WIDTH_QUANTITY = '105px';
export const MAX_LENGTH_PART_NUMBER = 20;

export enum ERROR_BUTTONS_TYPES {
  ERROR_MESSAGE = 'error-message',
  ERROR_FETCHING = 'error-fetching',
  CONTACT_DEALER = 'contact-dealer'
}
export const DEFAULT_SAVED_LISTS_PER_PAGE = 12;
export const DEFAULT_DISPLAY_NOTES_VALUES = {
  showCustomerPartNumber: true,
  showEquipmentNumber: true,
  showLineItemNote: true,
  showCustomerItemNumber: true
}
